import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ShareableLinkLockScreen from '../ShareableLinkLockScreen';
import { Button } from 'ncoded-component-library';
import useRequestAccess from '../../hooks/useRequestAccess';

import './ShareableLinkRequestAccess.styles.scss';

type ShareableLinkRequestAccessProps = {
  className?: string;
  shareableLinkId: string;
  requestedAccessAt: Date;
};

const ShareableLinkRequestAccess: React.FC<ShareableLinkRequestAccessProps> = (
  props,
) => {
  const { className, shareableLinkId, requestedAccessAt } = props;

  const {
    hasAlreadyRequestedAccess,
    hasRequestOrReminderSent,
    onSendReminder,
    onRequestAccess,
  } = useRequestAccess(shareableLinkId, requestedAccessAt);

  const classes = classNames('shareable-link-request-access', className);

  const { t } = useTranslation();

  const title = useMemo(
    () =>
      t(
        hasAlreadyRequestedAccess
          ? 'stillWaitingTheAccessRights'
          : 'youAreNotGrantedPermissionAccessLink',
      ),
    [hasAlreadyRequestedAccess, t],
  );

  const description = useMemo(
    () =>
      hasAlreadyRequestedAccess
        ? t('stillWaitingTheAccessRightsDescription')
        : '',
    [hasAlreadyRequestedAccess, t],
  );

  return (
    <ShareableLinkLockScreen
      title={title}
      description={description}
      className={classes}
    >
      <Button
        disabled={hasRequestOrReminderSent}
        onClick={hasAlreadyRequestedAccess ? onSendReminder : onRequestAccess}
      >
        {t(hasAlreadyRequestedAccess ? 'sendReminder' : 'requestAccess')}
      </Button>
    </ShareableLinkLockScreen>
  );
};

export default ShareableLinkRequestAccess;
